<template>
  <div class="order-tags">
    <CBadge
      v-for="(tag, index) in formattedTags"
      :key="`${tag.prefix}-${tag.value}-${index}`"
      shape="pill"
      color="light"
      class="order-tag mr-1 mb-1"
      @click="onTagClick(tag)"
    >
      <span class="tag-prefix">{{ tag.prefix }}:</span>
      <span class="tag-value">{{ tag.value }}</span>
    </CBadge>
  </div>
</template>

<script>
export default {
  name: 'OrderTags',
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    formattedTags() {
      if (!this.tags || !Array.isArray(this.tags)) return []
      
      return this.tags.map(tag => {
        const parts = tag.split(':')
        if (parts.length >= 2) {
          const prefix = parts[0]
          const value = parts.slice(1).join(':') // Handle cases where value contains ':'
          return { prefix, value, full: tag }
        }
        // If no prefix, treat entire string as value
        return { prefix: '', value: tag, full: tag }
      }).filter(tag => tag.value) // Filter out empty tags
    }
  },
  methods: {
    onTagClick(tag) {
      this.$emit('tag-click', {
        value: tag.value,
        prefix: tag.prefix,
        full: tag.full
      })
    }
  }
}
</script>

<style scoped lang="scss">
.order-tags {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.order-tag {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e4e7ea;
  background-color: #f8f9fa;
  color: #3c4043;
  font-size: 0.875rem;
  padding: 0.25rem 0.75rem;
  
  &:hover {
    background-color: #e9ecef;
    border-color: #ced4da;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
  
  .tag-prefix {
    font-weight: 600;
    color: #6c757d;
    margin-right: 2px;
  }
  
  .tag-value {
    color: #212529;
  }
}
</style>